import { IsNotEmpty, IsIn } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { ICourseSessionRegistrationStatus } from "./course-session-registration-status.interface";

export class CourseSessionRegistrationStatusDto
  implements ICourseSessionRegistrationStatus
{
  @IsNotEmpty()
  @IsIn(Object.values(Constants.course_session_attendance_status))
  status: string; // course session attendance status
}
